import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "page-hero",
  class: "w-full py-20 text-center lg:py-28 lg:text-left"
}
const _hoisted_2 = { class: "lg:w-1/2 lg:pr-8 relative z-30" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("dd", { class: "pt-2 pl-12 text-xl text-gray-500 font-gotham-bold" }, " Fast internet up to 1Gbps ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("dd", { class: "pt-2 pl-12 text-xl text-gray-500 font-gotham-bold" }, " Wide range of unlimited data plans ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("dd", { class: "pt-2 pl-12 text-xl text-gray-500 font-gotham-bold" }, " Flexible contracts ", -1)
const _hoisted_7 = ["src"]

import AddressSearch from './AddressSearch.vue';
import Container from './Container.vue';

import { CheckIcon } from '@heroicons/vue/outline';
import { Address } from '@/adapters/autocompleteAddressAdapterInterface';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';
import { Brand } from '../../services/integration/enums';


export default /*#__PURE__*/_defineComponent({
  props: {
    autocompletedAddresses: { type: Array, required: true },
    address: { type: String, required: true }
  },
  emits: ["onCheckAddressClicked", "onAddressSearchInputted", "onAutocompletedAddressClicked"],
  setup(__props: any, { emit }: { emit: ({(e: 'onCheckAddressClicked', address: string, done: () => void): void, (e: 'onAddressSearchInputted', address: string): void, (e: 'onAutocompletedAddressClicked', address: Address): void}), expose: any, slots: any, attrs: any }) {

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');






return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", {
    class: _normalizeClass([_unref(brandService).getName() === _unref(Brand).HIS ? 'bg-brand-accent-light' : '', "lg:relative w-full"])
  }, [
    _createVNode(Container, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h1", {
              class: _normalizeClass([_unref(brandService).getName() === _unref(Brand).HIS ? 'font-gotham-bold text-brand-secondary lg:text-4xl xl:text-6xl pb-4' : 'font-extrabold text-gray-900 lg:text-5xl xl:text-6xl', "text-4xl tracking-tight leading-none sm:text-5xl md:text-6xl"])
            }, _toDisplayString(_unref(brandService).getHeroTitle()), 3),
            _withDirectives(_createElementVNode("div", _hoisted_3, [
              _createElementVNode("dt", null, [
                _createVNode(_unref(CheckIcon), {
                  class: "absolute h-10 w-10 text-brand-primary",
                  "aria-hidden": "true"
                })
              ]),
              _hoisted_4,
              _createElementVNode("dt", null, [
                _createVNode(_unref(CheckIcon), {
                  class: "absolute h-10 w-10 text-brand-primary",
                  "aria-hidden": "true"
                })
              ]),
              _hoisted_5,
              _createElementVNode("dt", null, [
                _createVNode(_unref(CheckIcon), {
                  class: "absolute h-10 w-10 text-brand-primary",
                  "aria-hidden": "true"
                })
              ]),
              _hoisted_6
            ], 512), [
              [_vShow, _unref(brandService).getName() === _unref(Brand).HIS]
            ]),
            _createVNode(AddressSearch, {
              "autocompleted-addresses": __props.autocompletedAddresses,
              address: __props.address,
              onOnAutocompletedAddressClicked: _cache[0] || (_cache[0] = (address) => emit('onAutocompletedAddressClicked', address)),
              onOnCheckAddressClicked: _cache[1] || (_cache[1] = (address, done) => emit('onCheckAddressClicked', address, done)),
              onOnAddressSearchInputted: _cache[2] || (_cache[2] = (address) => emit('onAddressSearchInputted', address))
            }, null, 8, ["autocompleted-addresses", "address"])
          ])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", {
      class: _normalizeClass([_unref(brandService).getName() === _unref(Brand).HIS ? 'h-96' : 'h-64 sm:h-72 md:h-96', "relative w-full lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2 lg:h-full"])
    }, [
      _createElementVNode("img", {
        class: _normalizeClass([_unref(brandService).getName() === _unref(Brand).HIS ? 'h-full w-full object-cover overflow-visible' : 'absolute inset-0 w-full h-full object-cover', ""]),
        src: _unref(brandService).getHeroImage(),
        alt: ""
      }, null, 10, _hoisted_7)
    ], 2)
  ], 2))
}
}

})